import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token from localStorage if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qrmp_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ---- Global 401 handler ------------------------------------------------------
// When the backend rejects a request with 401 (expired / invalid token), we:
//   1. Clear the stale token from localStorage immediately
//   2. Mark a flag so the calling component knows this was an auth failure
//      (so it can show a friendly "please log in again" message instead of
//      the raw "Token expired" detail)
//   3. Surface a normalized error code on the response object
//
// We deliberately do NOT auto-navigate to /login here — that should be the
// caller's responsibility so it can save context (e.g. the pricing plan
// the user just clicked) before redirecting.
const PUBLIC_AUTH_ENDPOINTS = [
  "/auth/login",
  "/auth/register",
  "/auth/forgot-password",
  "/auth/reset-password",
];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isPublicAuthCall = PUBLIC_AUTH_ENDPOINTS.some((p) => url.includes(p));

    if (status === 401 && !isPublicAuthCall) {
      try { localStorage.removeItem("qrmp_token"); } catch (e) {}
      // Annotate error so callers can detect "session expired" cleanly.
      if (error.response) error.response.isAuthExpired = true;
      // Notify any listener (e.g. AuthContext) so it can clear user state.
      try {
        window.dispatchEvent(new CustomEvent("qrmp:auth-expired", { detail: { url } }));
      } catch (e) {}
    }
    return Promise.reject(error);
  }
);

export const PUBLIC_URL = BACKEND_URL;

export const setToken = (token) => {
  if (token) localStorage.setItem("qrmp_token", token);
  else localStorage.removeItem("qrmp_token");
};
